import React, { SVGProps } from 'react';

const LogoutIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 15 15"
			fill="none"
			{...props}
		>
			<path
				d="M12.9879 7.83166L8.76914 12.0504C8.68118 12.1384 8.56189 12.1878 8.4375 12.1878C8.31311 12.1878 8.19382 12.1384 8.10586 12.0504C8.0179 11.9625 7.96849 11.8432 7.96849 11.7188C7.96849 11.5944 8.0179 11.4751 8.10586 11.3871L11.5248 7.96877H2.34375C2.21943 7.96877 2.1002 7.91938 2.01229 7.83147C1.92439 7.74357 1.875 7.62434 1.875 7.50002C1.875 7.3757 1.92439 7.25647 2.01229 7.16856C2.1002 7.08065 2.21943 7.03127 2.34375 7.03127H11.5248L8.10586 3.61291C8.0179 3.52495 7.96849 3.40566 7.96849 3.28127C7.96849 3.15688 8.0179 3.03758 8.10586 2.94963C8.19382 2.86167 8.31311 2.81226 8.4375 2.81226C8.56189 2.81226 8.68118 2.86167 8.76914 2.94963L12.9879 7.16838C13.0315 7.21191 13.066 7.26361 13.0896 7.32051C13.1132 7.37742 13.1254 7.43842 13.1254 7.50002C13.1254 7.56162 13.1132 7.62261 13.0896 7.67952C13.066 7.73643 13.0315 7.78812 12.9879 7.83166Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default LogoutIcon;
